var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendgrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_571_22092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 10.0391H10.0191V20.0581H0V10.0391Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.1 10.1391H9.91906V19.9581H0.1V10.1391Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0195 20.0586H19.9805V30.0195H10.0195V20.0586Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1195 20.1586H19.8805V29.9195H10.1195V20.1586Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 30.0205H10.0191V30.0782H0V30.0205ZM0 20.0596H10.0191V30.0205H0V20.0596Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0814 19.9581V10.1972H29.9005V19.9581H20.0814ZM19.8805 0.178125V9.93906H10.1195V0.178125H19.8805Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0195 20.0591H19.9805V10.0391H10.0195V20.0591Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9805 0.078125H29.9995V10.0391H19.9805V0.078125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9805 10.0391H29.9995V10.0967H19.9805V10.0391Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_571_22092"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0 0.078125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendgrid);
export default __webpack_public_path__ + "static/media/sendgrid.ab4516707d98eda9c61d323614ae85bd.svg";
export { ForwardRef as ReactComponent };